import {Component} from "react";
import st_logo from "../../../assets/img/logos/smarttags_logo.png";
import verified_img from "../../../assets/img/registration/verified.png";
import back_icon from "../../../assets/img/registration/back-icon.png";
import React from "react";
import './style.scss';
import {connect} from "react-redux";
import {Col, Row, Button} from "reactstrap";
import IntlTelInput from "react-intl-tel-input";
import SocialLogins from './SocialMediaBtn/SocialMediaBtn'
import ImgBg from "./SideBgImg";

import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import {Button as SementicBtn, Dropdown, Icon, Input} from "semantic-ui-react";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import OtpInput from 'react-otp-input';
import {MDBModal, MDBModalBody} from "mdbreact";

import * as util from "../../../util/Validator";
import * as common from "../../../const/Common/CommonFunc";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import axiosAuth from "../../../axios/axios_authorization";
import Cookies from "js-cookie";
import apiConfig from "../../../axios/axios_api_services";
import Webcam from "react-webcam";
import * as actionCreator from "../../../store/Action";
import Countdown from "react-countdown";
import * as keys from "../../../const/key/Key";
import * as EmailValidator from "email-validator";
import * as qs from "qs";
import StaticEventView from "../../../views/public/update-details/static-event-view";
import axiosEventTags from "../../../axios/axios_eventtag";
import VisitorPhotoUploadWithFR from "../../../components/VisitorPhotoUpload/VisitorPhotoUploadWithFR";
import {PUBLIC_WEB_SIGN_IN_PAGE} from "../../../const/route/Route";
import PicUpload from "../../../assets/img/visitor_upload/pic-upload.png";

const initialState = {tab:1, screenshot: '', otp:'', isModal:false, validMobile: false, mobile:'', mobile_:'',
  firstName:'', lastName:'', gender:'', facingFront:true, identificationType:'NIC', identificationValue:'',date:Date.now() + 60000,
  email:'',validEmail:false, socialMediaToken:'', userSocialId:'', authType:'NORMAL', isStaticEvent: false, userId: 0,fromSignIn: false, isEventQRThrough: false, isCamOpen: false};

class App extends Component {

  state = Object.assign({}, initialState);

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.mobile) {
      let eventId = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID)
      this.setState({
        mobile_: this.props.location.state.mobile,
        tab: this.props.location.state.tab,
        fromSignIn: true,
        isEventQRThrough: !!eventId
      })
    }
  }

  componentWillMount(){
    if (this.props.match.params.code !== undefined){
      this.setState({
        tab:2,
        socialMediaToken:this.props.match.params.code,
        authType:'APPLE'
      })
    }
  }

  screenshotHandler = (screenshot) => {
    this.setState({
      screenshot: screenshot
    });
  };

  changeTab = (tab) => {
    this.setState({
      tab : tab
    })
  }

  // signUpAction =() => {
  //   // backend code
  //   this.changeTab(2)
  // }

  handleChange = (otp) => {
    this.setState({ otp });
  }

  verifyOtp = () => {
    this.props.spinnerHandler(false);
    this.setState({isModal:!this.state.isModal})
  }

  okAction = (type) => {
    switch (type) {
      case 'sign-in':
        this.props.history.replace(PUBLIC_WEB_SIGN_IN_PAGE)
        break;
      case 'sign-up':
        this.setState({...initialState})
        break;
      default:
        break;
    }
  }

  onHandleMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      validMobile:condition,
      mobile:value,
      mobile_: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  onHandleChange = name => e => {
    let value = e.target.value
    this.setState({
      [name] : value
    })

    if (name === 'email') {
      this.setState({
        validEmail: EmailValidator.validate(value)
      })
    }
  }

  onChangeGender = (e, { value }) => {
    this.setState({ gender: value })
  };

  handleFacingMode = () => {
    this.setState({facingFront: !this.state.facingFront})
  }

  caputureImageHandler = (screenshot) => {
    // let screenshot = this.refs.webcam.getScreenshot();
    this.setState({ screenshot: screenshot })
  };

  removeImg = () => {
    this.setState({ screenshot: '' })
  }

  commonFunc = name => (obj) => {
    // console.log(`${name}:`,obj);
  };

  renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <a onClick={() => this.sendOtp()}>Resend Code</a>
    } else {
      return <span>{`0${minutes}`}:{seconds > 9 ? seconds : `0${seconds}`}</span>;
    }
  };

  socialLoginData = (obj) => {
    this.setState({
      tab:2,
      firstName:obj.firstName,
      lastName:obj.lastName,
      email:obj.email,
      socialMediaToken:obj.socialMediaToken,
      userSocialId:obj.userSocialId,
      authType:obj.authType
    })
  }

  validateSignUp = (type) => {
    let {isEventQRThrough} = this.state;
    // eslint-disable-next-line default-case
    switch (this.state.tab) {
      case 1:
        this.state.validMobile ? this.verifyMobile() : common.notifyMessage("Please enter valid mobile no")
        break;
      case 2:
          this.state.firstName.trim() === '' ? common.notifyMessage("Please enter the first name") :
            this.state.lastName.trim() === '' ? common.notifyMessage("Please enter the last name") :
              this.state.authType !== 'NORMAL' && this.state.mobile.trim() === '' ? common.notifyMessage("Please enter the mobile") :
                this.state.authType !== 'NORMAL' && !this.state.validMobile ? common.notifyMessage("Please enter a valid mobile") :
                  // this.state.authType !== 'NORMAL' && this.state.email.trim() === '' ? common.notifyMessage("Please enter the email") :
                  //   this.state.authType !== 'NORMAL' && !this.state.validEmail ? common.notifyMessage("Please enter a valid email") :
                  !isEventQRThrough && this.state.gender.trim() === '' ? common.notifyMessage("Please select the gender") :
                        this.sendOtp()

        break;
      case 3:
        this.state.otp.trim() === '' ? common.notifyMessage("Please enter the otp") :
          this.state.otp.length !== 5 ? common.notifyMessage("Please enter the otp correctly") :
            this.signUpAction(type)
    }
  }

  verifyMobile = () => {

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosAuth.get(apiConfig.CHECK_MOBILE_EXIST(this.state.mobile_), {headers: headers})
      .then(response => {
        if (!response.data.success) {
          this.changeTab(2)
          /*if (response.data.message.substring(0,2) === 'No') {
            this.changeTab(2)
          } else {
            common.warningAlert("Mobile number is already registered in the system. Please use a new number.")
            this.setState({validMobile: false, mobile:'', mobile_:''})
          }*/
        }else{
          common.warningAlert(response.data.message)
          this.setState({validMobile: false, mobile:'', mobile_:''})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  sendOtp = () => {

    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/json"
    };

    axiosAuth.post(apiConfig.USER_SIGN_UP_SEND_OTP,{mobile:this.state.mobile_}, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (this.state.tab === 2) this.changeTab(3)
          this.setState({
            date: Date.now() + 60000,
            otp:''
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  signUpAction = (type) => {
    let {isEventQRThrough} = this.state;
    this.props.spinnerHandler(true);

    const data={
      "first_name": this.state.firstName,
      "last_name": this.state.lastName,
      "mobile": this.state.mobile_,
      "identification_type": this.state.identificationType,
      "identification_value": this.state.identificationValue,
      "gender": isEventQRThrough ? null : this.state.gender === "" ? null : this.state.gender,
      "photo_path": this.state.screenshot === '' ? null : this.state.screenshot,
      "email":this.state.email,
      "social_media_token":this.state.socialMediaToken,
      "user_social_id":this.state.userSocialId,
      "auth_type":this.state.authType,
      "is_web_sign_up":true
    }

    const headers = {
      "Content-Type": "application/json"
    };

    axiosAuth.post(apiConfig.USER_SIGN_UP(this.state.otp), data, {headers: headers})
      .then(response => {
        // console.log(response,type)
        if (response.data && (response.data.success === undefined || response.data.success)) {
          this.setState({userId: response.data.user.userId});
          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
          if (type === 'verify') {
            let eventId = sessionStorage.getItem(keys.SUB_EVENT_QR_UUID);
            if (eventId) {
              this.setState({isStaticEvent: true});
            } else {
              this.verifyOtp();
            }
            // this.getEventDetails(data);  // please comment
          } else {
            this.props.spinnerHandler(false);
            if(response.data.message) common.notifyMessage(response.data.message, 2)
            this.setState({...initialState})
          }
        } else {
          // please un-comment
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message)
          // this.getEventDetails(data);  // please comment
        }
      })
      .catch(async error => {
        this.props.spinnerHandler(false);
        let result = await common.checkErrorResponse(error);
        if (result === 1) {

        }
      })
      .finally(fin => {

      });
  }

  getEventDetails = (data) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization" : "Basic Y2V5ZW50cmE6"
    };

    const object = {
      username: data.mobile,
      password: this.state.otp,
      grant_type: 'password'
    }

    axiosAuth.post(apiConfig.OAUTH,qs.stringify(object),{headers:headers})
      .then(response => {
        if (response.status === 200) {
          // this.props.spinnerHandler(false); // please un-comment
          Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token);
          Cookies.set('9b8558ba3f051677daf36ebfc67f29fa', response.data.refresh_token);
          this.setState({isStaticEvent: true, userId: response.data.user.userId})  // please comment
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.notifyMessage(error.statusDesc, 0, 3);
        } else {
          common.notifyMessage("This PIN does not valid ", 0, 3);
        }
      });
  }

  backHandler = () => {
    let {tab,fromSignIn} = this.state;
    if (tab === 2 && fromSignIn) this.props.history.replace(PUBLIC_WEB_SIGN_IN_PAGE)
    if(tab !== 1 && tab === 2 ) {
      this.setState({...initialState})
    } else {
      this.setState({tab: tab - 1 })
    }
  }

  render() {
    let {tab, screenshot, otp, isModal, mobile,mobile_, firstName, lastName, gender, facingFront, identificationType,
    identificationValue, date, authType, email, isEventQRThrough, isCamOpen} = this.state;

    return (
      <Row style={{background:'white'}} className={'public-web-signup-layout'}>
        <ImgBg pgType={tab === 2 ? 'signUp' : 'signIn'}/>
        <Col className='signUp-div'>
          {tab !==1 ? <div className={"back-icon-wrapper"} onClick={this.backHandler}>
            <img src={back_icon} alt={"back-icon"} />
          </div>:null}
          <img src={st_logo} alt={"."} id={tab !== 3 ? 'st_logo' : 'st_logo_verify'}/>
          {
            tab === 1 ?
              <>
                <p className={'title'}>Create an Account</p>
                <div className={"mt-5"}>
                  {/*<Lbl>Mobile</Lbl>*/}
                  <IntlTelInput
                    style={{width: '100%', marginBottom:'30px'}}
                    type={"text"}
                    fieldName={"Mobile Number"}
                    value={mobile}
                    containerClassName="intl-tel-input dashboard-intl"
                    inputClassName="form-control"
                    onPhoneNumberChange={this.onHandleMobile}
                    required={true}
                    preferredCountries={['lk']}
                    defaultCountry={"lk"}
                    nationalMode={false}
                    icon='mobile alternate'
                    placeholder="Mobile Number"
                  />
                </div>
                <Button className={'done-btn'} onClick={() => this.validateSignUp('')}> Sign up</Button>
                <SocialLogins setData={this.socialLoginData} type={'sign-up'}/>
                <Row className={'download-app-sec-sign-up align-items-center justify-content-center'}>
                  <Col className={'d-flex align-items-end justify-content-center'}>
                    <p className="text-center desc-text">For an amazing experience, download the app today!
                    </p>
                  </Col>
                  <Col className={'d-flex align-items-start justify-content-center'}>
                    <a className="apps-btn wrap-1" role="button"
                       href={keys.SMART_APP_PLAY_STORE_APP}>
                      <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                    </a>
                    <a className="apps-btn wrap-1" role="button"
                       href={keys.SMART_APP_APP_STORE_APP}>
                      <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                    </a>
                  </Col>
                </Row>

              </> : tab === 2 ?
              <>
                <p className={'title mb-3'}>Create an Account</p>
                <Row>
                  <Col className={"align-center"} style={{ margin: "1vh 0 0" }}>
                    {!isCamOpen ? <img onClick={()=>this.setState({isCamOpen: true})} src={PicUpload} className={'pic-upload-img'} /> :
                    <VisitorPhotoUploadWithFR screenshotHandler={this.caputureImageHandler} screenshot={screenshot} style={{width: '200px'}} isSignUp={true} />}
                  </Col>
                </Row>
                <LabelInput
                  tagText={"First Name"}
                  placeholder={"First Name"}
                  value={firstName}
                  onChange={this.onHandleChange('firstName')}
                />
                <LabelInput
                  tagText={"Last Name"}
                  placeholder={"Last Name"}
                  value={lastName}
                  onChange={this.onHandleChange('lastName')}
                />
                {
                  authType !== 'NORMAL' && <>
                    <div className={"fb-mobile"}>
                      <label className="label ui dashboard-mobile-lbl">Mobile </label>
                      <IntlTelInput
                        type={"text"}
                        fieldName={"Mobile Number"}
                        value={mobile}
                        containerClassName="intl-tel-input dashboard-intl"
                        inputClassName="form-control"
                        onPhoneNumberChange={this.onHandleMobile}
                        required={true}
                        preferredCountries={['lk']}
                        defaultCountry={"lk"}
                        nationalMode={false}
                        placeholder={'Mobile'}
                      />
                    </div>
                    {
                      email !== '' &&
                      <LabelInput
                        tagText={"Email"}
                        placeholder={"Email"}
                        value={email}
                        disable={true}
                        inputClass={"gray-background"}
                        onChange={this.onHandleChange('email')}
                      />
                    }
                  </>
                }
                {!isEventQRThrough ? <LabelDropdown
                  // disable={this.state.isVisitor}
                  tagText={"Gender"}
                  placeholder={"Gender"}
                  options={DropDownConst.gender}
                  value={gender}
                  onChange={this.onChangeGender}
                />:null}
                <Button className={'done-btn'} onClick={() => this.validateSignUp('')}>Create Account</Button>
              </> :
              <>
                <p className={'title'}>Verify Number</p>
                <p>Enter the OTP sent to  <span>{mobile_}</span></p>
                <OtpInput
                  value={this.state.otp}
                  onChange={this.handleChange}
                  numInputs={5}
                  inputType={"tel"}
                  inputStyle={{margin:'0 10px 20px', width:'2.5em'}}
                  containerStyle={{justifyContent:'center'}}
                  // focusStyle={{border: '1px solid #FFAD33!important'}}
                  renderInput={(props) => <input {...props} />}
                />
                <Countdown key={date} date={date} renderer={this.renderer}/>

                <div>
                  <Button style={{width:'45%', marginRight:'8px'}} className={'done-btn'} onClick={() => this.validateSignUp('verify')}>Verify</Button>
                  { !this.state.fromSignIn && <Button style={{width: '45%'}} className={'done-btn'} onClick={() => this.validateSignUp('add')}>Verify
                    and Add New</Button>}
                </div>

              </>
          }
          {
          isModal &&
          <MDBModal isOpen={isModal}  toggle={() => this.verifyOtp()} size="sm">
            <MDBModalBody>
              <div>
                <img src={verified_img} width='auto' height='42px'/>
                <p className={'title'} style={{paddingTop: '10px'}}>Congratulations!</p>
                <p  style={{margin:0}}>You have successfully create the account.</p>
                <Button className={'done-btn'} style={{width:'75%'}} onClick={() => {this.state.fromSignIn ? this.okAction('sign-in') : this.okAction('sign-up')}}>Ok</Button>
                <p className="text-center download-text">Download the App Now!</p>
                <div className='store-div'>
                  <a className="store-btn wrapper-1" role="button"
                     href={keys.SMART_APP_PLAY_STORE_APP} target={"_blank"}>
                    <img src="/app-assets/play-store-badge.png" alt="play-store-badge"/>
                  </a>
                  <a className="store-btn wrapper-2" role="button"
                     href={keys.SMART_APP_APP_STORE_APP} target={"_blank"}>
                    <img src="/app-assets/app-store-badge.svg" alt="app-store-badge"/>
                  </a>
                </div>

              </div>
            </MDBModalBody>
          </MDBModal>
        }
        </Col>
        {
          this.state.isStaticEvent ? <StaticEventView refresh={()=>{this.props.history.replace(PUBLIC_WEB_SIGN_IN_PAGE)}} closeHandler={()=>this.setState({...initialState})} userId={this.state.userId}/>:null
        }
      </Row>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(null, mapDispatchToProps)(App);
